import React, {useImperativeHandle, useMemo, useRef} from 'react';
import PropTypes from 'prop-types';
import {useComponentProps, useEffectEvent} from 'helpers/hooks/utils';
import StyledChooseTaskWizardContent
  from 'components/organisms/WizardContent/ChooseTaskWizardContent/ChooseTaskWizardContent.styles';
import constants from 'helpers/constants';
import useMediaQuery from '@mui/material/useMediaQuery';

const ChooseTaskWizardContent = React.forwardRef((props, ref) => {
  const {
    wizard,
    step,
    taskTypes,
    ...innerProps
  } = useComponentProps(props, 'ChooseTaskWizardContent');

  const innerRef = useRef(null);
  const setDataEvent = useEffectEvent(wizard.setData);

  useImperativeHandle(ref, () => innerRef.current);

  const xsDown = useMediaQuery((theme) => theme.breakpoints.down('xs'));

  const fields = useMemo(() => ([{
    name: 'type',
    label: 'Choose a task',
    inlineLabel: 'Task',
    entity: 'task',
    type: constants.formFieldTypes.category,
    conversion: constants.formFieldTypes.none,
    options: (taskTypes ?? constants.data.taskTypes),
    required: true,
    FormFieldProps: {
      CategoryCardProps: {
        size: xsDown ? 'smaller' : null,
        density: xsDown ? 'denser' : null
      }
    }
  }]), [taskTypes, xsDown]);

  const handleChange = (field, value) => {
    setDataEvent?.((current) => ({
      ...current,
      [wizard.dataKey]: {
        ...current[wizard.dataKey],
        type: value,
        collaborationType: value?.collaborationType
      }
    }));
  }

  const handleSubmit = (values) => {
    setDataEvent?.((current) => ({
      ...current,
      [wizard.dataKey]: {
        ...current[wizard.dataKey],
        type: values['type'],
        collaborationType: values['type']?.collaborationType
      }
    }));
  }

  return <StyledChooseTaskWizardContent ref={innerRef} {...innerProps}
                                        wizard={wizard}
                                        step={step}
                                        fields={fields}
                                        onChange={handleChange}
                                        onSubmit={handleSubmit}
                                        InlineFormProps={{autoFocus: false}}/>
});

ChooseTaskWizardContent.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  wizard: PropTypes.object,
  step: PropTypes.object,
  taskTypes: PropTypes.array
};

export default ChooseTaskWizardContent;
